import { render, staticRenderFns } from "./detailsContent.vue?vue&type=template&id=97073ea2&scoped=true&"
import script from "./detailsContent.vue?vue&type=script&lang=ts&"
export * from "./detailsContent.vue?vue&type=script&lang=ts&"
import style0 from "./detailsContent.vue?vue&type=style&index=0&id=97073ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97073ea2",
  null
  
)

export default component.exports